module.exports = __webpack_public_path__ + "img/icon-basicEduS-31.6e68aa1b.png";